import { Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { AuthProvider } from "./context/AuthContext";
import { NotificationProvider, PrivateRoute } from "@cakrawalajakarta/shared-components";
import { Admintiming } from "./pages/Admintiming";
import { InputBIB } from "./pages/InputBIB";
import { Results } from "./pages/Results";
import { Layout } from "./components/Layout";
import { MidtransScript } from "@cakrawalajakarta/shared-components";

import Beranda from "./Beranda";
import { SectionKategori } from "@cakrawalajakarta/shared-components";

// Dynamic imports untuk komponen besar
const Berita = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Berita })));
const TentangKami = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.TentangKami })));
const Kontak = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Kontak })));
const Profile = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Profile })));
const Login = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Login })));
const Register = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Register })));
const Actions = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Actions })));
const Verify = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Verify })));
const LupaPassword = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.LupaPassword })));
const Sukses = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Sukses })));
const DetailBerita = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.DetailBerita })));
const AddNews = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.AddNews })));
const SyaratKetentuan = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.SyaratKetentuan })));
const KebijakanPrivasi = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.KebijakanPrivasi })));
const SuratPernyataan = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.SuratPernyataan })));
const FormPendaftaran = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.FormPendaftaran })));
const PesananSaya = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.PesananSaya })));
const EntryList = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.EntryList })));
const Xtrifeinnie = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.Xtrifeinnie })));
const StravaCallback = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.StravaCallback })));
const StravaStats = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.StravaStats })));
const KategoriDetail = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.KategoriDetail })));
const PesananDetail = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.PesananDetail })));
const AdminSectionCourses = lazy(() => import("@cakrawalajakarta/shared-components").then(module => ({ default: module.AdminSectionCourses })));

const App = () => {
  return (
    <AuthProvider>
      <NotificationProvider>
        <MidtransScript />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Beranda />} />
              <Route path="kategori" element={<SectionKategori />} />
              <Route path="/:slug/:distance" element={<KategoriDetail />} />
              <Route path="entrylist/:eventId" element={<EntryList />} />
              <Route
                path="Xtrifeinnie"
                element={
                  <PrivateRoute>
                    <Xtrifeinnie />
                  </PrivateRoute>
                }
              />
              <Route path="/strava-callback" element={<StravaCallback />} />
              <Route
                path="/strava-stats"
                element={
                  <PrivateRoute>
                    <StravaStats />
                  </PrivateRoute>
                }
              />
              <Route path="Berita" element={<Berita />} />
               <Route path="Admintiming" element={<Admintiming />} />
                <Route path="InputBIB" element={<InputBIB />} />
                 <Route path="Results" element={<Results />} />
              <Route path="Tentangkami" element={<TentangKami />} />
              <Route path="Kontak" element={<Kontak />} />
              <Route path="Login" element={<Login />} />
              <Route path="Register" element={<Register />} />
              <Route path="PesananSaya" element={<PesananSaya />} />
                   <Route path="/pesanan-detail" element={<PesananDetail />} />
              <Route path="AddNews" element={<AddNews />} />
               <Route path="AdminSectionCourses" element={<AdminSectionCourses />} />
              <Route path="news/:id" element={<DetailBerita />} />
              <Route path="SyaratKetentuan" element={<SyaratKetentuan />} />
              <Route path="KebijakanPrivasi" element={<KebijakanPrivasi />} />
              <Route path="SuratPernyataan" element={<SuratPernyataan />} />
              <Route path="Sukses" element={<Sukses />} />
              <Route path="Actions" element={<Actions />} />
              <Route path="Verify" element={<Verify />} />
              <Route path="LupaPassword" element={<LupaPassword />} />
              <Route path="form/:slug" element={<FormPendaftaran />} />
              <Route
                path="Profile"
                element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                }
              />
            </Route>
          </Routes>
        </Suspense>
      </NotificationProvider>
    </AuthProvider>
  );
};

export default App;